import React from "react";
import {
  ArrowRight,
  BriefcaseBusiness,
  Package,
  Settings,
  TrendingUp,
  UsersRound,
} from "lucide-react";
import businessJourneyImg from "../../../../assets/images/Landing_Page/ChatGPTImageSep21-2026-03-02-01PM1-4k-lossy.webp";
import { journeyPills } from "../data/content";

export default function BusinessJourney() {
  return (
    <section className="section-py bg-lavender">
      <div className="container text-center">
        <h2 className="section-title">SELECTEZI Business Journey</h2>

        <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-4">
          {journeyPills.map((pill, i) => (
            <React.Fragment key={pill}>
              <span
                className={
                  i === journeyPills.length - 1
                    ? "btn-selectezi-primary py-2 px-3"
                    : "footer-link-btn"
                }
                style={
                  i === journeyPills.length - 1
                    ? { fontSize: "0.8rem" }
                    : {
                        background: "var(--white)",
                        color: "var(--blue-600)",
                        border: "1px solid var(--lavender-200)",
                        fontSize: "0.8rem",
                        padding: "0.6rem 1rem",
                        display: "inline-block",
                        borderRadius: "0.5rem",
                        fontWeight: 700,
                      }
                }
              >
                {pill}
              </span>
              {i < journeyPills.length - 1 && (
                <ArrowRight size={16} color="var(--blue-300)" />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="diagram-card business-journey-card mt-4">
          <div className="diagram-image-frame">
            <img src={businessJourneyImg} alt="SELECTEZI Business Journey" />
          </div>

          <p className="business-journey-description">
            A business can begin with a Showcase and gradually build a network
            of customers, suppliers, partners, service providers and other
            resources.
          </p>

          <div className="business-journey-footer">
            <span className="business-journey-rule" aria-hidden="true" />
            <ul className="business-journey-highlights">
              <li>
                <BriefcaseBusiness aria-hidden="true" />
                <span>Your Business</span>
              </li>
              <li>
                <Package aria-hidden="true" />
                <span>Your Products</span>
              </li>
              <li>
                <Settings aria-hidden="true" />
                <span>Your Services</span>
              </li>
              <li>
                <UsersRound aria-hidden="true" />
                <span>Your Market</span>
              </li>
              <li>
                <TrendingUp aria-hidden="true" />
                <span>Your Opportunity</span>
              </li>
            </ul>
            <span className="business-journey-rule" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}
